"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSuiTurnstileState = exports.TurnstileEnabledFeature = exports.SuiTurnstileProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactTurnstile = require("@marsidev/react-turnstile");
var _sendErrorToSentry = require("ErrorBoundary/sendErrorToSentry");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TURNSTILE_SCRIPT_NOT_LOADED = "Turnstile script not loaded";
var VALIDATION_FAILED_USING_TURNSTILE = "Validation failed using turnstile";
var ERR_CODE_TOKEN_EXPIRED = "cf_token_expired";
var ShowSpinner = function ShowSpinner(flag) {
  var spinner = document.getElementById('spinner');
  if (spinner) {
    spinner.style.display = flag ? 'block' : 'none';
  }
};
;
var TurnstileEnabledFeature = exports.TurnstileEnabledFeature = /*#__PURE__*/function (TurnstileEnabledFeature) {
  TurnstileEnabledFeature["klass_code_login"] = "klass_code_login";
  TurnstileEnabledFeature["parent_and_teacher_signup"] = "parent_and_teacher_signup";
  return TurnstileEnabledFeature;
}({});
var SuiTurnstileContext = /*#__PURE__*/_react["default"].createContext({});
var SuiTurnstileProvider = exports.SuiTurnstileProvider = function SuiTurnstileProvider(_ref) {
  var _window, _APP_CONFIG, _APP_CONFIG2;
  var userType = _ref.userType,
    action = _ref.action,
    children = _ref.children,
    featureName = _ref.featureName,
    dontShowSpinner = _ref.dontShowSpinner;
  var ref = _react["default"].useRef();
  var attemptRef = (0, _react.useRef)(0);
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    token = _useState2[0],
    setToken = _useState2[1];
  var securityFlowEnabled = (_window = window) === null || _window === void 0 || (_window = _window.turnstile_enabled_features) === null || _window === void 0 ? void 0 : _window[featureName];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isTurnstileLoading = _useState4[0],
    setTurnstileLoading = _useState4[1];
  (0, _react.useEffect)(function () {
    if (securityFlowEnabled) {
      setTurnstileLoading(true);
    }
    return function () {
      setTurnstileLoading(false);
      ShowSpinner(false);
      window.cfTurnstileToken = null;
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (!dontShowSpinner) {
      ShowSpinner(isTurnstileLoading);
    }
  }, [isTurnstileLoading]);
  var logEvent = function logEvent(msg, errorCode) {
    var eventData = {
      validatedUserType: userType,
      custom_user_type: "unverified_user",
      error_code: errorCode
    };
    var trackingOptions = {
      send_datadump: true,
      send_mixpanel: true,
      send_clevertap: false
    };
    trackEventsForGuests(msg, eventData, trackingOptions);
    (0, _sendErrorToSentry.sendErrorToSentry)(new Error(msg), {
      errorCode: errorCode
    });
    setTimeout(function () {
      return ShowSpinner(false);
    }, 2000);
  };
  var clearToken = function clearToken() {
    setToken(null);
    window.cfTurnstileToken = null;
  };
  var refreshToken = function refreshToken() {
    if (securityFlowEnabled) {
      if (attemptRef.current < 2) {
        var _ref$current;
        setTurnstileLoading(true);
        ref === null || ref === void 0 || (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.reset();
      }
      attemptRef.current++;
    }
  };
  var refreshOnTokenExpiry = function refreshOnTokenExpiry() {
    var _ref$current2;
    clearToken();
    if ((_ref$current2 = ref.current) !== null && _ref$current2 !== void 0 && _ref$current2.isExpired()) {
      refreshToken();
    }
  };
  var handleTurnstileError = function handleTurnstileError(errorCode) {
    setTurnstileLoading(false);
    refreshOnTokenExpiry();
    logEvent(VALIDATION_FAILED_USING_TURNSTILE, errorCode);
  };
  var handleOnExpire = function handleOnExpire(token) {
    setTurnstileLoading(false);
    refreshOnTokenExpiry();
    logEvent(VALIDATION_FAILED_USING_TURNSTILE, ERR_CODE_TOKEN_EXPIRED);
  };
  var handleTurnstileSuccess = function handleTurnstileSuccess(token) {
    setToken(token);
    window.cfTurnstileToken = token;
    setTurnstileLoading(false);
  };
  return /*#__PURE__*/_react["default"].createElement(SuiTurnstileContext.Provider, {
    value: {
      token: token,
      refreshToken: refreshToken,
      isTurnstileLoading: isTurnstileLoading
    },
    "data-sentry-element": "unknown",
    "data-sentry-component": "SuiTurnstileProvider",
    "data-sentry-source-file": "SuiTurnstile.tsx"
  }, children, securityFlowEnabled && ((_APP_CONFIG = APP_CONFIG) === null || _APP_CONFIG === void 0 || (_APP_CONFIG = _APP_CONFIG.turnstile) === null || _APP_CONFIG === void 0 ? void 0 : _APP_CONFIG.siteKey) && /*#__PURE__*/_react["default"].createElement(_reactTurnstile.Turnstile, {
    ref: ref,
    siteKey: (_APP_CONFIG2 = APP_CONFIG) === null || _APP_CONFIG2 === void 0 || (_APP_CONFIG2 = _APP_CONFIG2.turnstile) === null || _APP_CONFIG2 === void 0 ? void 0 : _APP_CONFIG2.siteKey,
    onError: handleTurnstileError,
    onExpire: handleOnExpire,
    onSuccess: handleTurnstileSuccess,
    scriptOptions: {
      defer: true,
      onError: function onError() {
        clearToken();
        setTurnstileLoading(false);
        logEvent(TURNSTILE_SCRIPT_NOT_LOADED, "script_load_failed");
      }
    },
    options: {
      action: action,
      theme: 'light'
    }
  }));
};
var useSuiTurnstileState = exports.useSuiTurnstileState = function useSuiTurnstileState() {
  var context = (0, _react.useContext)(SuiTurnstileContext);
  if (!context) {
    console.warn("Use useSuiTurnstileState in SuiTurnstileProvider");
  }
  return context;
};